import { OxGristEditor } from './ox-grist-editor.js'
import { customElement } from 'lit/decorators.js'
import { html } from 'lit'

@customElement('ox-grist-editor-password')
export class OxGristEditorPassword extends OxGristEditor {
  get editorTemplate() {
    return html` <input type="password" .value=${this.value} /> `
  }
}
